import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Space, theme } from 'antd';

import { useSelector, useUserRole } from '../../../hooks/usePrerenderUser';
import USER_ROLES from '../../auth/userRoles';
import { dates } from '~library/dates';
import { useReactivatePlan } from '../hooks/useReactivatePlan';
import { useSubscriptionState } from '../PlanStatus';
import SubscriptionReactivationModal from './SubscriptionReactivationModal';

const MANAGE_SUBSCRIPTION_HREF = '/billing/plans';

function SubscriptionCancelledBanner() {
  const { token } = theme.useToken();
  const cancelledAt = useSelector((state) => state.prerenderUser.cancelledAt);
  const planName = useSelector((state) => state.prerenderUser.planName);
  const userRole = useUserRole();
  const [planState] = useSubscriptionState();
  const { startReactivation, isModalOpen, modalProps } = useReactivatePlan('global_banner');

  if (!isModalOpen && (planState.status !== 'cancelled' || !cancelledAt)) {
    return null;
  }

  const formattedDate = cancelledAt ? dates.dayOfPointInTime(cancelledAt) : '';
  const isRestrictedBillingRole = [USER_ROLES.GUEST, USER_ROLES.TEAM_MEMBER].includes(userRole);
  const description = isRestrictedBillingRole
    ? 'Reactivate your plan to ensure crawlers receive fully rendered pages and can see your site’s content. Please contact your Account Owner.'
    : 'Reactivate your plan to ensure crawlers receive fully rendered pages and can see your site’s content.';

  return (
    <>
      <SubscriptionReactivationModal {...modalProps} />
      <Alert
        showIcon
        style={{ margin: token.margin }}
        type="error"
        message={`Your paid plan ended on ${formattedDate}. Rendering is currently paused.`}
        description={description}
        action={
          !isRestrictedBillingRole ? (
            <Space direction="vertical" size={4} align="center">
              <Button type="primary" onClick={startReactivation}>
                Reactivate {planName} Plan
              </Button>
              <Link style={{ color: token.colorPrimary }} to={MANAGE_SUBSCRIPTION_HREF}>
                Manage subscription
              </Link>
            </Space>
          ) : undefined
        }
      />
    </>
  );
}

export default SubscriptionCancelledBanner;
